import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f4b2441"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-editor" }

import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { Content, ContentTag, ItemType } from '@/rd/ResearchDataModel'
import { useContentStore } from '@/rd/ContentStore'
import { useContentTagStore } from '@/rd/ContentTagStore'
import { LoadMode } from '@/util/AsyncData'
import ContentItem from './ContentItem.vue'
import { Environment } from '@/util/Environment'
import { useTokenManager } from '@/auth/TokenManager'
import { CompositeId } from '@/rd/CompositeId'
import { DateTime } from 'luxon'
import { AsyncUtil } from '@/util/AsyncUtil'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentEditor',
  props: {
    itemType: {},
    itemId: {}
  },
  setup(__props: any) {

const props = __props;



const contentStore = useContentStore()
const contentTagStore = useContentTagStore()
const tokenManager = useTokenManager()

const tagsRef = computed(() => contentTagStore.getTagsForItems(props.itemType, [props.itemId], LoadMode.EnsureLoaded))

// onMounted(() => {
//   uppy.on('file-added', async (file) => {
//     try {
//       const groupId = CompositeId.getGroupId(props.itemId)!
//       const newContent = new Content()
//       newContent.fileName = file.name
//       newContent.dataModifiedDate = DateTime.utc()
//       const contentId = await contentStore.addAsync(groupId, newContent)
//       console.log(`ContentEditor: content ${contentId} created`)

//       const uploadUrl = `${Environment.get('RESEARCH_DATA_URL')}content/${contentId}/data?size=${file.data.size}`
//       const xhrPlugin = uppy.getPlugin('XHRUpload')
//       xhrPlugin?.setOptions({
//         endpoint: uploadUrl,
//       })
//       console.log(`ContentEditor: content upload url: ${uploadUrl}`)

//       await uppy.upload()
//       console.log(`Content ${contentId} upload succeeded: ${file.name}`)

//       // TODO: wait for server notification when content processing completed?
//       contentStore.trackAsyncContents([contentId], LoadMode.Reload)

//       const newTag = new ContentTag()
//       newTag.contentId = contentId
//       newTag.itemType = props.itemType
//       newTag.itemId = props.itemId
//       const tagId = await contentTagStore.addAsync(newTag)
//     }
//     catch (error) {
//       console.log(`ContentEditor: Error uploading file ${file.name}`, error)
//       uppy.removeFile(file.id)
//     }
//   })
// })

// onBeforeUnmount(() => {
//   uppy.destroy()
// })

// function onBeforeUpload(xhr: XMLHttpRequest) {
//   xhr.setRequestHeader('Authorization', `Bearer ${tokenManager.current.token}`)
// }

// function onAfterUpload(xhr: XMLHttpRequest) {
//   return {} // empty response
// }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagsRef.value, (t) => {
      return (_openBlock(), _createElementBlock("div", {
        key: t.id
      }, [
        _createVNode(ContentItem, {
          "content-id": t.contentId,
          "content-tag-id": t.id
        }, null, 8, ["content-id", "content-tag-id"])
      ]))
    }), 128))
  ]))
}
}

})